import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import type { LiveQuoteReviewRow } from 'helpers/liveSlipSubmit';
import { ThemeIcon } from 'components/ThemeIcon/ThemeIcon';
import styles from './SlipCreationModalContent.module.css';
import { SlipCreationModalTypes } from 'types/enums';

interface Props {
  modalType: SlipCreationModalTypes;
  onConfirm?: (() => void) | undefined;
  onReject?: (() => void) | undefined;
  liveQuoteReviewRows?: LiveQuoteReviewRow[];
}

export const SlipCreationModalContent = ({
  modalType,
  onConfirm,
  onReject,
  liveQuoteReviewRows = [],
}: Props) => {
  const { t } = useTranslation();
  const suspended = modalType === SlipCreationModalTypes.QUOTE_SUSPENDED;
  const asksYesNo =
    suspended || modalType === SlipCreationModalTypes.CONFIRM_CREATING;

  if (modalType === SlipCreationModalTypes.LIVE_QUOTE_REVIEW) {
    return (
      <div className={classNames(styles.wrapper, styles.wrapperQuoteReview)}>
        <div className={styles.title}>INFO</div>
        <div className={styles.quoteReviewBody}>
          <p className={styles.quoteReviewIntro}>
            {t('live_quote_review_intro')}
          </p>
          <table className={styles.quoteTable}>
            <thead>
              <tr>
                <th>{t('live_quote_selection_label')}</th>
                <th>{t('live_quote_before_label')}</th>
                <th>{t('live_quote_after_label')}</th>
              </tr>
            </thead>
            <tbody>
              {liveQuoteReviewRows.map((row) => (
                <tr key={row.key}>
                  <td className={styles.quoteSelectionCell}>{row.label}</td>
                  <td className={styles.quoteOddCell}>{row.before}</td>
                  <td className={styles.quoteOddCell}>{row.after}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div
          className={classNames(
            styles.buttonsWrapper,
            styles.quoteReviewButtons
          )}
        >
          <button
            type="button"
            onClick={onReject}
            className={styles.rejectButton}
          >
            <ThemeIcon icon="remove" alt="" variant="inline" tone="chrome" />
            {t('no_label')}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className={styles.confirmButton}
          >
            <ThemeIcon
              icon="check-lg-white"
              alt=""
              variant="inline"
              tone="chrome"
            />
            {t('live_quote_accept_submit_label')}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>INFO</div>
      <div className={styles.middle} data-modal-type={modalType}>
        {asksYesNo ? (
          <>
            <ThemeIcon icon="question" alt="" variant="inline" />
            <span>
              {t(
                suspended
                  ? 'quote_suspended_message'
                  : 'submit_bet_slip_message'
              )}
            </span>
          </>
        ) : (
          <>
            <ThemeIcon icon="success-checkmark" alt="Info" variant="inline" />
            <span>{t('slip_creation_success_message')}</span>
          </>
        )}
      </div>
      <div className={styles.buttonsWrapper}>
        {asksYesNo ? (
          <>
            <button
              type="button"
              onClick={onReject}
              className={styles.rejectButton}
            >
              <ThemeIcon
                icon="remove"
                alt="Info"
                variant="inline"
                tone="chrome"
              />
              {t('no_label')}
            </button>
            <button
              type="button"
              onClick={onConfirm}
              className={styles.confirmButton}
            >
              <ThemeIcon
                icon="check-lg-white"
                alt="Info"
                variant="inline"
                tone="chrome"
              />
              {t('yes_label')}
            </button>
          </>
        ) : (
          <button type="button" onClick={onConfirm}>
            <ThemeIcon icon="chevron-right" alt="Info" variant="inline" />
            {t('close_label')}
          </button>
        )}
      </div>
    </div>
  );
};
